// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-1b3e6ebc]{border-collapse:collapse}table[data-v-1b3e6ebc],td[data-v-1b3e6ebc],th[data-v-1b3e6ebc]{border:.5px solid #000}.pink-light-araporcei[data-v-1b3e6ebc]{background-color:#ec81b3}@media print{.pink-light-araporcei[data-v-1b3e6ebc]{background-color:#ec81b3!important;-webkit-print-color-adjust:exact!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
